/**
 * Routines rollout gate. The feature is only surfaced (nav link + route) for
 * the organizations listed here; everyone else is bounced to "/" and never sees
 * the link. Extend the set to widen the rollout.
 */
export const ROUTINES_ORGANIZATION_IDS = new Set<string>([
    '019f80b4-1ca7-7000-976b-0fcfd35b42a1', // River Road Veterinary Hospital
    '018ee238-891a-7001-aab7-dc931c2b0fe2', // Tal Test Clinic
    '0185644d-9383-7000-b35d-6e31e1158b43', // NerveX Admin
    '019bb3a5-b385-7000-96fe-2859897d0609', // Demo
]);

export const isRoutinesEnabledFor = (organizationId: string | null | undefined): boolean =>
    !!organizationId && ROUTINES_ORGANIZATION_IDS.has(organizationId.toLowerCase());
